<div class="sso">
  <div class="divider">Or log in with</div>
  <div class="drivers">
    @if (!waitingForSSO) {
      <div class="sso-row">
        <img
          class="sso-img-btn"
          [src]="'/assets/sso/ms.svg'"
          alt="Sign in with Microsoft"
          role="button"
          tabindex="0"
          (click)="loginViaSSO('microsoft')"
          (keydown.enter)="loginViaSSO('microsoft')"
        />
        @if (showOkta) {
          <img
            class="sso-img-btn"
            [src]="'/assets/sso/octa.png'"
            alt="Sign in with Okta"
            role="button"
            tabindex="0"
            (click)="loginViaSSO('octa')"
            (keydown.enter)="loginViaSSO('octa')"
          />
        }
      </div>
    }
    @if (waitingForSSO) {
      <app-spinner [message]="null" [small]="true"></app-spinner>
    }
  </div>
</div>
